
namespace TabAurous.Master {

    @Serenity.Decorators.registerClass()
    export class EmployeeDetailsGrid extends Serenity.EntityGrid<EmployeeDetailsRow, any> {
        protected getColumnsKey() { return 'Master.EmployeeDetails'; }
        protected getDialogType() { return EmployeeDetailsDialog; }
        protected getIdProperty() { return EmployeeDetailsRow.idProperty; }
        protected getInsertPermission() { return EmployeeDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return EmployeeDetailsRow.localTextPrefix; }
        protected getService() { return EmployeeDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}